module.exports = __webpack_public_path__ + "img/scene-5.bd15b5c.png";